<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              formControlName="Naziv"
              [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
              [Label]="'GOTOVINSKIKOMITENT.NAZIV.SINGULAR'"
              [MaxLength]="200">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
              <span *ngFor="let validation of errorMessages.Naziv">
                <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
        </div>
       
        <div class="form-group row">
          <div class="col-md-10 col-md-9 col-9">
            <yt-input
              [Type]="'text'"
              formControlName="Pib"
              [ngClass]="{'is-invalid': submitted && fc.Pib.invalid}"
              [Label]="'GOTOVINSKIKOMITENT.PIB.SINGULAR'"
              [MaxLength]="9">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Pib.invalid">
              <span *ngFor="let validation of errorMessages.Pib">
                <span class="error-message" *ngIf="fc.Pib.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
          <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end">
              <span class="input-group-append">
                  <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.PIB.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetCompanyDataByPib()" ><span class="fa fa-fw fa-download"></span></button><!--[disabled]="loadingCompanyData"-->
              </span>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-10 col-md-9 col-9">
            <yt-input
              [Type]="'text'"
              formControlName="MatBr"
              [ngClass]="{'is-invalid': submitted && fc.MatBr.invalid}"
              [Label]="'GOTOVINSKIKOMITENT.MATBR.SINGULAR'"
              [MaxLength]="8">
            </yt-input>           
          </div>
          <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end">
                <span class="input-group-append">
                    <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.MATICNIBROJ.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetCompanyDataByMatBr()" ><span class="fa fa-fw fa-download"></span></button> <!--[disabled]="loadingCompanyData"-->
                </span>
            </div> 
        </div>

        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              formControlName="Adresa"
              [ngClass]="{'is-invalid': submitted && fc.Adresa.invalid}"
              [Label]="'GOTOVINSKIKOMITENT.ADRESA.SINGULAR'"
              [MaxLength]="200">
            </yt-input>           
          </div>
        </div>


        <div class="form-group row">
          <div class="col-md-12">

            <!-- <yt-dropdown-picklist
            [ModelName]="'mesto'"
            [GetName]="'get'"
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            [AllowAddNew]="false"
            formControlName="MestoID"
            [Label]="'GOTOVINSKIKOMITENT.MESTO.SINGULAR'"
            >
            </yt-dropdown-picklist> -->

            <yt-autocomplete
            [ModelName]="'mesto'"
            [GetName]="'getByNaziv'"
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            [Label]="'GOTOVINSKIKOMITENT.MESTO.SINGULAR'"
            formControlName="MestoID">
          </yt-autocomplete>

            <div class="form-error" *ngIf="submitted && fc.MestoID.invalid">
              <span *ngFor="let validation of errorMessages.MestoID">
                <span class="error-message" *ngIf="fc.MestoID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>